<ngb-tab id="tab-selectbyid2">
    <ng-template ngbTabTitle>Order Review Attachments </ng-template>

    <div class="form-row mt-2">
        <table class="table table-responsivetable-striped" aria-hidden="true">
            <thead>
                <tr>
                    <th scope="col"><b>Image</b></th>
                    <th scope="col" style="width:30%;"><b>File Name</b></th>
                    <th scope="col"><b>Date & Time</b></th>
                    <th scope="col"><b>Created by</b></th>
                    <th scope="col"><b>Action</b></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let doc of orderdoc">
                    <tr>
                        <td *ngIf="orderdoc && doc.FileName!= null && doc.FieldName != 'Onedrive Link'">
                            <img src="{{url + doc.UrlPath}}" alt="" class="img-thumbnail user-attachment-img">
                        </td>
                        <td *ngIf="(orderdoc && doc.FileName == null) || doc.FieldName == 'Onedrive Link'">
                            <img src="{{ dft_icn }}" alt="" class="img-thumbnail user-attachment-img">
                        </td>

                        <td>{{doc.FieldName}}</td>
                        <td>{{doc.CreatedDate}} {{doc.CreatedTime}}</td>
                        <td>{{doc.CreatedBy}}</td>

                        <td *ngIf="orderdoc && doc.FileName == null && doc.FieldName != 'Onedrive Link'">
                            <div class="d-flex" *ngIf="permission.OrderReview_AttachmentUpload == 1 || roleId==1">
                                <a href="javascript:void(0);"
                                    class="btn bg-light-info btn btn-circle align-items-center d-flex justify-content-center"
                                    placement="bottom" ngbTooltip="Upload"
                                    (click)="openModal(upload, doc.FieldName, doc.TypeId); closeModalFileUplaodFalse()"><span
                                        class="mdi mdi-cloud-upload mdi-18px"></span></a>
                            </div>
                        </td>
                        <td *ngIf="orderdoc && doc.FileName != null && doc.FieldName != 'Onedrive Link'">
                            <div class="d-flex" *ngIf="permission.OrderReview_AttachmentDownload == 1 || roleId==1">
                                <a href="javascript:void(0);"
                                    class="btn bg-light-primary btn btn-circle align-items-center d-flex justify-content-center mr-1"
                                    placement="bottom" ngbTooltip="Download"
                                    (click)="downloadModal(downloadConfirm,doc.FieldName, downloadurl+doc.FileName); closeModalFileUplaodFalse()"><span
                                        class="mdi mdi-download mdi-18px"></span></a>

                                <a href="javascript:void(0);"
                                    class="btn bg-light-warning btn btn-circle align-items-center d-flex justify-content-center"
                                    placement="bottom" ngbTooltip="Delete"
                                    (click)="deleteOpenModal(deleteConfirm,doc.FieldName,doc.FileId,orderdoc)"><span
                                        class="mdi mdi-delete"></span></a>
                            </div>
                        </td>
                        <td *ngIf="orderdoc && doc.FieldName != null && doc.FieldName == 'Onedrive Link'">
                            <form [formGroup]="OnedriveForm">
                                <div class="d-flex" *ngIf="permission.OrderReview_AttachmentUpload == 1 || roleId==1">
                                    <textarea class="form-control" maxlength="250" [(ngModel)]="oneDriveLink"
                                        formControlName="DriveId" (input)="NameSpaceNotAllowed($event)"
                                        title="{{oneDriveLink}}"></textarea>
                                    <button
                                        *ngIf="!OnedriveForm.get('DriveId').invalid && !OnedriveForm.get('DriveId').errors && OnedriveForm.get('DriveId').value"
                                        href="javascript:void(0);" class="btn btn-info ml-2 btn-td"
                                        (click)="addMediaPost('Onedrive Link', 16); closeModalFileUplaodFalse()"
                                        title="Save">Save</button>
                                    <button
                                        *ngIf="(OnedriveForm.get('DriveId').invalid || OnedriveForm.get('DriveId').errors) || !OnedriveForm.get('DriveId').value"
                                        href="javascript:void(0);" class="btn btn-info ml-2 btn-td"
                                        title="Save">Save</button>
                                </div>
                                <div
                                    *ngIf="OnedriveForm.get('DriveId').invalid && OnedriveForm.get('DriveId').errors && (OnedriveForm.get('DriveId').dirty || OnedriveForm.get('DriveId').touched) || submitted">
                                    <small class="text-danger" *ngIf="OnedriveForm.get('DriveId').hasError('pattern')">
                                        Invalid Link Address
                                    </small>
                                </div>
                            </form>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>

    <ng-template #upload>
        <div *ngIf="mediaUploadDisplay">
            <div class="modal-header modal-header-new">
                <h4><strong>Order Review Attachments</strong></h4>
            </div>

            <div class="modal-body modal-body-new" appDrag (files)="filesDropped($event)">
                <div class="media">
                    <div class="w-100">
                        <p>{{type}}</p>
                        <div class="form-group" style="background-color:#3f97bd; color: #fff;">
                            <div class="text-comment">
                            </div>
                            <a href="javascript:void(0)"
                                class="image-upload d-flex bg-light-new p-2 align-items-center">
                                <label for="file-input" placement="bottom" class="d-block mb-0 w-100 text-center">
                                    <h5 class="mb-0 font-bold text-white text-center" style="color:white;">Upload Media
                                        Files</h5>
                                </label>
                                <input id="file-input" (click)="fileInput.value = null" #fileInput type="file"
                                    class="d-none"
                                    accept="image/png,image/jpeg,image/webp,image/gif,image/aac,.doc,.docx,.pdf,.zip,.rar,.txt,.ppt,.pptx,.csv,.xls,.xlsx"
                                    multiple (change)="fileChangeEvent($event);" value="" [disabled]="btnLoader" />
                            </a>
                        </div>

                        <div class="d-flex pt-2" style="overflow-x: auto;">
                            <div *ngFor="let images of imgURL; let i = index" [attr.data-index]="i">
                                <div *ngIf="imgURL" class='position-relative' style="height: 150px;">
                                    <div>
                                        <a href="javascript:void(0);" (click)="RemoveImage(images, i)"
                                            class='position-absolute close_img-new my-element'><span
                                                class='mdi mdi-close text-dark'></span></a>
                                        <img *ngIf="images.type == 'image'" class='mx-2 mb-1 border obj-fit'
                                            src='{{images.url}}' alt="">
                                        <video *ngIf="images.type == 'video'" [muted]="true"
                                            class='mx-2 mb-1 border obj-fit' [src]='images.url'>
                                            <track label="English" kind="captions" srclang="en" src="resources/myvideo-en.vtt" default>
                                        </video>
                                    </div>
                                    <div *ngIf="images.name" class="text-center" ngbTooltip="{{images.name}}"
                                        placement="auto">
                                        <p class="text-dark font-weight-normal previewTestLimit">{{
                                            (images.name.length>10)
                                            ? (images.name | slice:0:10)+'...':(images.name ) }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="file_upload_loader" class='text-center'>
                            <div class='spinner-border text-info'><span class='sr-only'></span></div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center border-top border-light pt-2">
                            <div class="send-btn mt-3">
                                <button *ngIf="((fileUploadCount > 0) && !file_upload_loader) && btnLoader==false"
                                    class="btn btn-info  btn-sm ml-2" (click)="addMediaPost(type, DocTypeId);"
                                    placement="top" ngbTooltip="Upload">
                                    <span class="mdi mdi-send"></span>
                                    Upload
                                </button>
                                <button *ngIf="btnLoader==true" class="btn btn-info  btn-sm ml-2"><span
                                        class="spinner-grow spinner-grow-sm"></span> Uploading...</button>

                                <span> <button type="button" *ngIf="btnLoader==false"
                                        class="btn btn-secondary btn-sm ml-2" placement="top" ngbTooltip="Close"
                                        (click)="closeModalFileUplaodFalse();modalRef.hide();">Close</button></span>
                                <span *ngIf="mediaPostArr.mediaPostText?.length >= 2000" class="text-danger ml-3 fs-12">
                                    You cannot enter more than 2000 characters.</span>

                                <span
                                    *ngIf="postMediaGreaterThanCheckError && mediaPostArr.mediaPostText?.length < 2000"
                                    class="text-danger ml-3 fs-12"><strong>{{postMediaGreaterThanCheckError}}</strong></span>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="section_type && section_type==2" class="modal-body" appDrag (files)="filesDropped($event)">
                <div class="media">
                    <div class="w-100">
                        <p class="centered-text">{{type}}</p>
                        <div class="form-group">
                            <div class="text-comment">
                                <textarea name="mediaPostText" (ngModelChange)="this.mediaUrlLinkString.next($event)"
                                    (paste)="handlePaste($event)" maxlength="2000"
                                    [(ngModel)]="mediaPostArr.mediaPostText" #mediaPostText="ngModel" rows="3"
                                    class="form-control" placeholder="{{openforum_post_placeholder}}"></textarea>
                            </div>
                            <a href="javascript:void(0)" class="image-upload d-flex bg-light p-2 align-items-center">
                                <label for="file-input" placement="bottom" class="d-block mb-0 w-100">
                                    <h5 class="mb-0 font-bold text-dark text-center">Upload Media Files</h5>
                                </label>
                                <input id="file-input" (click)="fileInput.value = null" #fileInput type="file"
                                    accept="image/png,image/jpeg,image/webp,image/gif,image/aac,.doc,.docx,.pdf,.zip,.rar,.txt,.ppt,.pptx,.csv,.xls,xlsx"
                                    multiple (change)="fileChangeEvent($event)" value="" />
                            </a>
                        </div>
                        <div class="d-flex" style="overflow-x: auto;">
                            <div *ngFor="let images of imgURL; let i = index" [attr.data-index]="i">
                                <div *ngIf="imgURL" class='position-relative'>
                                    <div>
                                        <a href="javascript:void(0);" (click)="RemoveImage(images, i)"
                                            class='position-absolute close_img my-element'><span
                                                class='mdi mdi-close text-white'></span></a>
                                        <img *ngIf="images.type == 'image'" class='mx-2 mb-1 border obj-fit'
                                            src='{{images.url}}' alt="">
                                        <video *ngIf="images.type == 'video'" [muted]="true"
                                            class='mx-2 mb-1 border obj-fit' [src]='images.url'>
                                            <track label="English" kind="captions" srclang="en" src="resources/myvideo-en.vtt" default>
                                            </video>
                                    </div>
                                    <div *ngIf="images.name" class="text-center" ngbTooltip="{{images.name}}"
                                        placement="auto">
                                        <p class="text-dark font-weight-normal previewTestLimit">{{images.name}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="text-center" *ngIf="file_upload_loader">
                            <div class="spinner-border text-info" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center border-top border-light pt-2">
                            <div class="send-btn mt-3">
                                <button
                                    *ngIf="(fileUploadCount > 0 || (mediaPostArr.mediaPostText?.length > 0 && mediaPostArr.mediaPostText?.length < 2001)) && !file_upload_loader"
                                    (click)="openModalPrivacy(postPrivacyMediaConf);" class="btn btn-sm btn-info"
                                    placement="top" ngbTooltip="Send" [disabled]="clicked">
                                    <img src="{{platform_icon.shout_icon}}" class="img-fluid" alt="..." width="20">
                                    Shout
                                </button>
                                <span
                                    *ngIf="(mediaPostArr.mediaPostText?.length > 2000 || (fileUploadCount == 0 && mediaPostArr.mediaPostText?.length == 0) || file_upload_loader)">
                                    <a href="javascript:void(0);" class="btn btn-sm btn-light" placement="top"
                                        ngbTooltip="Send">
                                        <img src="{{platform_icon.shout_icon}}" class="img-fluid" alt="..." width="20">
                                        Shout
                                    </a>
                                </span>
                                <span> <button type="button" class="btn btn-sm btn-post-cancel ml-2" placement="top"
                                        ngbTooltip="Close"
                                        (click)="closeModalFileUplaodFalse();modalRef.hide();">Close</button></span>
                                <span *ngIf="mediaPostArr.mediaPostText?.length >= 2000" class="text-danger ml-3 fs-12">
                                    You cannot enter more than 2000 characters.</span>
                                <span
                                    *ngIf="postMediaGreaterThanCheckError && mediaPostArr.mediaPostText?.length < 2000"
                                    class="text-danger ml-3 fs-12">{{postMediaGreaterThanCheckError}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="allowDragover">
                <div class="container h-100">
                    <div class="row h-100 justify-content-center align-items-center">
                        <div class="center text-center text-dark">Drop your file Here!</div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #deleteConfirm>
        <div class="modal-body text-center">
            <p>Do you want to delete {{filename}}?</p>
            <button type="button" class="btn btn-info btn-sm" (click)="deletefileinfo(); modalRef.hide();"
                [disabled]="delNameDel">Delete</button>
            <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline()">Cancel</button>
        </div>
    </ng-template>

    <ng-template #downloadConfirm>
        <div class="modal-body text-center">
            <p>Do you want to Download {{filename}} ?</p>
            <button type="button" class="btn btn-info btn-sm" (click)="download(); modalRef.hide();"
                [disabled]="delNameDel">Download</button>
            <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline()">Cancel</button>
        </div>
    </ng-template>

</ngb-tab>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>